import { HomeHeader } from '@hungryroot/homepage';
import { islandRoot } from '../IslandRoot/IslandRoot';

export const HomeHeaderIsland = islandRoot(HomeHeader);
